import { useEffect, useState } from 'react';

import { isBrowser } from 'modules/global';

import { ISocialMedia } from '../models';

export const useStoreItem = () => {
  const [storeItem, setStoreItem] = useState<ISocialMedia | null>(null);

  useEffect(() => {
    if (!isBrowser()) return;

    const { userAgent } = navigator;
    const isIOS = /iPhone|iPad|Macintosh/.test(userAgent);

    const item: ISocialMedia = isIOS
      ? {
          name: 'App Store',
          logo: '/images/appstore.webp',
          bgColor: 'bg-teal-200',
          url: 'https://apps.apple.com/de/app/akam-onlayn-testlar/id1619248324'
        }
      : {
          name: 'Play Market',
          logo: '/images/playmarket.webp',
          bgColor: 'bg-gray-200',
          url: 'https://play.google.com/store/apps/details?id=com.test.aim.uz'
        };

    setStoreItem(item);
  }, []);

  return storeItem;
};
